export default {
    //Splash
    splash_message: 'Plateforme de communication et de formation',

    //TTCC
    accept_ttcc: 'Accepter les conditions générales',

    //Login
    welcome: 'Bienvenue!',
    welcome_message: 'dots, votre nouvel allié technologique en communication et formation.',
    username: "Nom d'utilisateur",
    password: 'Mot de passe',
    code: 'Code',
    recover_password: 'Récupérer le mot de passe',
    log_in: 'Se connecter',
    log_in_biometrics: 'Connectez-vous avec des données biométriques',
    create_user: 'Créer un utilisateur',
    recover_access_to_account: "Entrez votre nom d'utilisateur pour récupérer l'accès à votre compte",
    back: 'Retour',
    enter_new_password: 'Entrez le code et votre nouveau mot de passe',
    enter_code: 'Entrer le code',
    new_password: 'Nouveau mot de passe',
    repeat_new_password: 'Répéter le nouveau mot de passe',
    validate: 'Valider',
    complete_all_fields: 'Remplissez tous les champs',
    passwords_do_not_match: 'Les mots de passe ne correspondent pas',
    user_created_successfully: 'Utilisateur créé avec succès',
    required_fields: 'Champs requis',
    confirm_your_email: 'Confirmez votre e-mail',
    confirm_password: 'Confirmez le mot de passe',
    confirm_your_phone: 'Confirmez votre téléphone',
    confirm_password: 'Confirmez votre mot de passe',
    modifying_email: 'Vous modifiez votre e-mail',
    validate_code: 'Valider le code',
    code_sent_successfully: 'Code envoyé avec succès',
    password_reset: 'Votre mot de passe a été réinitialisé avec succès',
    enter_confirmation_code: 'Entrez votre code de confirmation',
    enter_your_new_email: 'Entrez votre nouvel e-mail',
    //nuevos al 01-08-2024
    user_does_not_exist: "Oups ! Nous n'avons pas trouvé votre compte",
    contact_the_administrator:
        "Il semble que l'utilisateur que vous avez saisi n'existe pas.\nVérifiez qu'il est correctement écrit\nou contactez l'administrateur.",
    invalid_user_or_pass: 'Nom d´utilisateur et/ou mot de passe invalide',
    info_is_not_correct: 'Certaines informations sont incorrectes, veuillez réessayer.',
    enter_user: 'Veuillez entrer un nom d´utilisateur',
    nonexistent_user: 'Utilisateur inexistant. Veuillez réessayer.',
    incorrect_code: 'Code incorrect',
    change_saved_successfully: 'Changement enregistré avec succès',
    pass_changed_successfully: 'Le mot de passe a été changé avec succès',
    check_your_email: 'Vérifiez votre e-mail pour entrer le code de validation',
    eight_characters: '*Doit contenir plus de 8 caractères',
    one_uppercase_letter: '*Doit contenir au moins 1 lettre majuscule',
    one_special_character: '*Doit contenir au moins 1 caractère spécial (@,$,!,#,?)',
    pass_requirements:
        'Vous devez remplir les conditions suivantes:\n\n*Doit contenir plus de 8 caractères\n*Doit contenir au moins 1 lettre majuscule\n*Doit contenir au moins 1 caractère spécial (ex: $, !, #, ?)',
    select_date: 'Sélectionnez une date',
    cannot_create_password: 'Impossible de créer un mot de passe',
    complete_your_details: 'Complétez vos informations pour continuer',
    validate_code: 'Validez le code',
    enter_valid_number: 'Vous devez entrer un numéro valide',
    complete_numbers:
        'Le préfixe "15" doit être supprimé pour que le numéro final ait un total de 13 chiffres, exemple: +54 9 XXX XXX XXXX, vous devez compléter les 10 chiffres restants.',

    //Profile
    insufficient_permissions: 'Permissions insuffisantes',
    permissions_are_required: "Des permissions sont nécessaires pour accéder à l'appareil photo et à la galerie de photos.",
    choose_font: 'Choisissez la source',
    where_do_you_want: "Où souhaitez-vous sélectionner l'image?",
    camera: 'Caméra',
    gallery: 'Galerie',
    edit_photo: 'Modifier la photo',
    cancel: 'Annuler',
    save: 'Enregistrer',
    app: 'App',
    support: 'Support',
    other: 'Autre',
    contact_channel: 'Canal de contact',
    select_the_contact_channel: 'Sélectionnez le canal de contact',
    subject: 'Sujet',
    write_the_subject: 'Écrivez le sujet',
    message: 'Message',
    write_a_comment: 'Écrire un commentaire',
    send: 'Envoyer',
    sent_successfully: 'Envoyé avec succès',
    thank_you_for_leaving_us_your_comments: 'Merci de nous avoir laissé vos commentaires, vous serez bientôt contacté.',
    close: 'Fermer',
    check_for_update: 'Vérifier les mises à jour',
    clear_cache: 'Effacer le cache',
    delete_account: 'Supprimer le compte',
    log_out: 'Se déconnecter',
    notifications: 'Notifications',
    insufficient_permissions: 'Permissions insuffisantes',
    permissions_to_access: "Des permissions sont nécessaires pour accéder à l'appareil photo et à la galerie de photos.",
    choose_font: 'Choisissez la source',
    select_the_image: "Où souhaitez-vous sélectionner l'image?",
    change_language: 'Changer la langue',
    change_language_title: 'Important!',
    change_language_message:
        'Pour réaliser cette action, il est nécessaire de disposer d’une connexion internet. Cela supprimera le contenu téléchargé pour une utilisation hors ligne. Veuillez noter que le changement n’affectera que le contenu de l’application et non la structure de l’application, qui dépend de la langue de votre appareil.',
    logout_not_available: 'Déconnexion non disponible',
    cant_logout:
        "Vous ne pouvez pas vous déconnecter pour le moment car vous n'êtes pas connecté à Internet. Veuillez vérifier votre connexion et réessayer.",
    //nuevos al 01-08-2024
    cache_cleared: 'Cache vidé avec succès',
    deletes_the_content:
        'Cette action supprime le contenu téléchargé pour une utilisation de l´application en mode hors ligne. Assurez-vous d´être connecté pour continuer à naviguer.',
    error_uploading_image: 'Erreur lors du téléchargement de l´image : ',
    there_was_an_error: 'Une erreur s´est produite lors du téléchargement de l´image. Veuillez réessayer.',
    //nuevos al 21-11-2024
    email: 'E-mail',
    phone: 'Téléphone',
    name: 'Prénom',
    last_name: 'Nom de famille',
    role: 'Rôle',
    verify: 'Vérifier',
    verified: 'Vérifié',
    contact_channels: 'Canaux de contact',
    editing_your_email: 'Vous êtes en train de modifier votre e-mail',
    editing_your_phone: 'Vous êtes en train de modifier votre numéro de téléphone',
    modifying_your_email:
        "Vous modifiez votre e-mail, vous recevrez un code dans votre e-mail pour le saisir. Si vous n'avez pas encore reçu le code, veuillez le vérifier à nouveau.",
    modifying_your_phone:
        "Vous modifiez votre numéro de téléphone portable, vous recevrez un code SMS pour le saisir. Si vous n'avez pas encore reçu le code, veuillez le vérifier à nouveau.",

    //Notifications
    all: 'Tout',
    unread: 'Non lu',
    read: 'Lu',
    seen: 'Vu',
    notifications: 'Notifications',
    here_you_will_find: 'Vous trouverez ici toutes les alertes et notifications!',
    mark_all_read: 'Tout marquer comme lu',
    you_have_no_notifications: "Vous n'avez aucune notification!",
    you_will_soon_start: 'Vous commencerez bientôt à recevoir de nouvelles communications',

    //Buscador
    enter_your_search: 'Entrez votre recherche',
    no_results: 'Aucun résultat',
    search_content: 'Recherchez du contenu qui vous intéresse.',
    see: 'Voir',
    results_in: 'résultats dans',
    see_less_results: 'Voir moins de résultats',
    all: 'Tout',
    wall: 'Mur',
    learning: 'Apprentissage',
    benefits: 'Avantages',
    portfolio: 'Portfolio',
    retry: 'Réessayer',
    locked: 'Verrouillé',
    pending: 'En attente',
    seen: 'Vu',
    approved: 'Approuvé',

    //Posts
    see_them: 'Voir tous les ',
    _comments: ' commentaires',
    reactions_from_other_users: 'Réactions des autres utilisateurs',
    not_connected_to_the_network: "Vous n'êtes pas connecté au réseau",
    comment: 'Commentaire',
    comments: 'Commentaires',
    write_a_comment: 'Écrire un commentaire',
    no_content: 'Pas de contenu',
    reaction: 'Réaction',
    reactions: 'Réactions',
    first_comment: 'Soyez le premier à laisser un commentaire!',
    no_comment: "Il n'y a pas encore de commentaires sur ce post.",
    write_a_comment: 'Écrire un commentaire',
    no_publications: 'Pas de publications',
    no_post_to_read: "Vous n'avez aucun post à lire.",
    views: 'vues',
    reply: 'Répondre',
    see: 'Voir ',
    more_answers: 'plus de réponses',
    hide: 'Masquer ',
    answers: ' réponses',
    no_reactions: 'Pas encore de réactions!',
    leave_your_reaction: 'Soyez le premier à laisser votre réaction.',
    //nuevos al 01-08-2024
    full_survey: 'Vous avez complété l’enquête !',
    thanks_for_participating: 'Merci d’avoir participé ! Gardez un œil sur le mur pour plus de mises à jour.',
    sent_automatically: 'Il sera envoyé automatiquement lorsque vous retrouverez la connexion.',
    no_post_saved: 'Aucun message enregistré pour le moment',
    see_your_favorite_content: 'Vous verrez ici votre contenu favori.',
    //fechas
    instant: 'Il y a quelques instants',
    hourFirst: 'Il y a ',
    hour: ' heure',
    hours: ' heures',
    day: ' jour',
    days: ' jours',

    //Learning
    congratulations: 'Félicitations!',
    you_approved: 'Vous avez réussi avec ',
    you_completed: 'Vous avez terminé ce cours',
    you_disapproved: 'Évaluation désapprouvée',
    score: 'Score:',
    return_to_course: "Retour à l'accueil",
    retry: 'Réessayer',
    it_is_available: 'Il est maintenant disponible',
    total_course_evaluation: 'Évaluation totale du cours',
    evaluate_me: 'ÉVALUEZ-MOI',
    completed_the_course: 'Vous avez terminé le cours',
    pending_approval: "En attente d'approbation",
    return: 'Retour',
    continue_course: 'Continuer le cours',
    you_have_made: 'Vous avez complété ',
    of_the_course: ' du cours',
    locked: 'verrouillé',
    pending: 'en attente',
    seen: 'vu',
    complete: 'complète',
    reprobate: 'échoué',
    sync_pend: 'sync pend.',
    in_progress: 'en cours',
    perform_evaluation: "Effectuer l'évaluation",
    next_content: 'Prochain contenu',
    you_completed_all: 'Vous avez terminé tous les contenus',
    final_evaluation: 'ÉVALUATION FINALE',
    retry_mayus: 'RÉESSAYER',
    see_more: '...plus',
    see_less: '...moins',
    back_to_course: 'RETOUR AU COURS',
    click_to_see: 'Cliquez pour voir',
    //Evaluaciones
    evaluation: 'Évaluation: ',
    of: ' de ',
    loading_evaluation: "Chargement de l'évaluation...",
    select_option: 'Vous devez sélectionner une option pour continuer',
    select_one_answer: 'Veuillez sélectionner au moins une réponse pour chaque question.',
    exit_evaluation: "Voulez-vous quitter l'évaluation?",
    your_answers_will_not_be_saved: 'Si vous quittez maintenant, vos réponses ne seront pas enregistrées',
    continue_evaluation: "Continuer l'évaluation",
    leave_anyway: 'Quitter quand même',
    try_again: 'Réessayer!',
    passed_the_evaluation: "Vous avez réussi l'évaluation",
    start_the_course_again: "Vous n'avez pas obtenu une note suffisante pour réussir l'évaluation. Revenez au cours pour pouvoir la réussir.",
    evaluation_pending_approval: "Évaluation en attente d'approbation",
    notification_result_evaluation: 'Vous recevrez bientôt une notification avec le résultat de votre évaluation',
    write_here: 'Écrivez ici...',
    close: 'Fermer',
    confirm: 'Confirmer',
    sync_pending: 'Synchronisation en attente',
    view_certificate: 'Afficher le certificat',
    // nuevos al 27-01-2025
    course_download_in_process: 'Téléchargement du cours en cours',
    course_is_downloading:
        'Veuillez patienter quelques secondes. Le cours est en cours de téléchargement pour que vous puissiez accéder à tout le contenu hors ligne sans problème.',
    downloaded_course: 'Cours téléchargé avec succès',
    you_can_train_offline: "C'est fait ! Vous pouvez désormais vous entraîner hors ligne.",
    delete_offline_course: 'Voulez-vous supprimer le téléchargement de ce cours hors ligne ?',
    not_view_course_offline: 'Vous ne pourrez pas voir ce cours hors ligne.',
    course_is_not_available: "Le cours n'est plus disponible...",
    not_available_offline: "Il n'est plus disponible hors ligne, mais vous pouvez le télécharger à nouveau lorsque vous en aurez besoin.",
    content_download_in_process: 'Téléchargement du contenu en cours',
    content_is_downloading:
        'Veuillez patienter quelques secondes. Le contenu est en cours de téléchargement pour que vous puissiez y accéder hors ligne sans problème.',
    downloaded_content: 'Contenu téléchargé avec succès',
    delete_offline_content: 'Voulez-vous supprimer le contenu hors ligne ?',
    not_view_content_offline: 'En le supprimant, vous ne pourrez plus accéder au contenu hors ligne.',
    content_is_not_available: "Le contenu n'est plus disponible...",
    download_offline: 'Télécharger hors ligne',
    available_offline: 'Disponible hors ligne',
    delete: 'Supprimer',

    //Stores
    your_progress_in_stores: 'Votre progression dans les magasins',
    map: 'Carte',
    daily_survey: 'Enquête quotidienne',
    survey: 'Enquête',
    matutino: 'MATIN',
    vespertino: 'VESPERTIN',
    form: 'Formulaire',
    enter_a_number: 'Entrez un numéro',
    campaign_expiration: 'EXPIRATION DE LA CAMPAGNE: ',
    store_indicators: 'Indicateurs de magasin',
    last_days: 'Correspondant aux 30 derniers jours',
    main_indicators: "Connaître l'évolution des principaux indicateurs en magasin",
    store_information: 'Trouver des informations pertinentes sur le magasin pour atteindre des niveaux optimaux de Perfect Store',
    perform_executions: "Effectuez les exécutions suivantes pour connaître l'état du magasin",
    pending_mayus: 'EN ATTENTE',
    approved_mayus: 'APPROUVÉ',
    in_review_mayus: 'EN REVUE',
    redo_mayus: 'REFAIRE',
    visited_mayus: 'VISITÉ',
    visited_mayus_sync: 'VISITÉ SYNC',
    visited_store_mayus: 'MAGASINS VISITÉS',
    checkin_realized_sync: 'MAGASINS VISITÉS SYNC',
    moderation_mayus: 'MODÉRATION',
    review_mayus: 'REVISION',
    in_progress_mayus: 'EN COURS',
    sync_pend_mayus: 'SYNC PEND.',
    locked_mayus: 'VERROUILLÉ',
    complete_mayus: 'COMPLET',
    perfect_store: 'Perfect Store',
    execution: 'Exécution',
    vouchers: 'Bons',
    send: 'Envoyer',
    requires: 'Requiert ',
    variation: 'Variation',
    validity: 'Validité: ',
    points: 'points',
    voucher_canceled: 'Bon annulé',
    you_can_try_again: 'Ne vous inquiétez pas! Vous pouvez réessayer.',
    voucher_successful: 'Bon réussi',
    successful_promo: 'La promotion a été terminée avec succès!',
    voucher_pending: 'Bon en attente',
    wait_for_the_validation: 'Attendez que votre bon soit validé',
    your_code_is_being_scanned: 'Votre code est en cours de numérisation ⏳',
    view_qr: 'Voir le QR',
    return_to_store: 'Retour au magasin',
    stores_objective: "Il doit atteindre l'objectif des magasins.",
    welcome_stores: 'Nous vous souhaitons la bienvenue dans les magasins!',
    tip_day: 'Ici, vous pouvez visiter vos magasins du jour, remplir les enquêtes correspondantes et consulter votre progression.',
    close_mayus: 'FERMER',
    select_form: 'Sélectionnez un formulaire pour commencer',
    select_one_form: "Pour commencer l'enquête, vous devez sélectionner l'un des formulaires.",
    answer_all_questions: 'Vous devez répondre à toutes les questions pour continuer.',
    schedule_not_found: "L'horaire d'aujourd'hui n'a pas été trouvé.",
    form_not_found: "Formulaire non trouvé dans l'horaire.",
    send: 'Envoyer',
    check_in: 'Check-in',
    check_out: 'Check-out',
    check_out_done: 'Check-out terminé',
    off_route: "Vous êtes hors route, entrez ici pour revenir à l'agenda pour",
    search_barcode: 'Rechercher par code-barres',
    no_agenda_today: "Vous n'avez pas d'agenda pour aujourd'hui!",
    no_agenda_week: "Vous n'avez pas d'agenda pour la semaine!",
    no_information_today: "Vous n'avez pas d'agenda pour cette date, si vous avez des questions, consultez votre superviseur.",
    no_information_week:
        "Nous ne recevons pas d'informations pour votre utilisateur, si vous avez des questions, veuillez contacter votre superviseur.",
    //nuevos al 01-08-2024
    not_have_camera_permissions: 'Vous n’avez pas les autorisations de caméra',
    activate_from_settings: 'Activez-le depuis les paramètres de votre appareil pour pouvoir continuer.',
    modify_permissions: 'Modifier les autorisations',
    complete_fields: 'Complétez les champs suivants pour créer un magasin',
    create: 'Créer',
    store_name: 'Nom du magasin',
    enter_store_name: 'Entrez le nom du magasin',
    sore_address: 'Adresse',
    enter_sore_address: "Entrez l'adresse du magasin",
    cluster: 'Cluster',
    store_phone: 'Téléphone',
    enter_sore_phone: 'Entrez le téléphone du magasin',
    activate_survey: 'Pour activer l´enquête 1.1 Vespertino, vous devez compléter les objectifs de magasins. Objectifs : ',
    inactive_vespertino: 'Vespertino inactif',
    active_vespertino: 'Vespertino actif',
    completed_your_mandatory_objectives: 'Vous avez complété vos objectifs obligatoires du jour, vous pouvez maintenant réaliser votre Vespertino.',
    complete_now: 'Compléter maintenant',
    perform_later: 'Réaliser plus tard',
    back_to_your_agenda: 'Souhaitez-vous revenir à votre agenda du jour ?',
    return_to_the_current_day:
        'Vous visualisez les activités de vos jours précédents, si vous touchez continuer, vous reviendrez au jour en cours : ',
    continue: 'Continuer',
    reached_your_goal: 'Vous avez atteint votre objectif !',
    search_by_barcode: 'Rechercher par code-barres',
    scan_the_barcode: 'Scannez le code-barres de tout produit\nsur la liste de ce relevé.',
    return_to_form: 'Retour au formulaire',
    product_not_found: 'Produit non trouvé',
    code_does_not_match: 'Le code ne correspond à aucun produit lié à ce formulaire.',
    search_another_product: 'Rechercher un autre produit',
    form_submitted_successfully: ' a réussi!',
    send_new_survey: 'Si vous le souhaitez, vous pouvez envoyer un nouveau sondage.',
    no_agenda_for_today: "Pas d'agenda pour aujourd'hui!",
    consult_your_supervisor: "Vous n'avez pas d'agenda pour cette date, pour toute question consultez votre superviseur.",
    visiting_your_store: 'Vous visitez votre magasin ',
    you_can_check_out: "Vous pouvez faire le check-out sans compléter l'enquête: ",
    you_met_the_goal: "Vous avez atteint l'objectif, il n'est pas nécessaire de compléter le formulaire.",
    you_must_complete_the_survey: "Pour faire le check-out, vous devez compléter l'enquête: ",
    checkin_blocked: 'Check-in bloqué',
    close_the_open_checkin: 'Pour continuer, vous devez fermer le check-in ouvert.',
    close_the_checkin_opened_in: 'Pour continuer, vous devez fermer le check-in ouvert à: ',
    checkin_out_of_range: 'Check-in hors de portée',
    more_meters_from_the_store: 'Vous êtes à plus de 150 mètres du magasin.',
    now_is_your_turn: "C'est maintenant votre tour!",
    surveys_in_progress: 'Vous avez des enquêtes en cours: ',
    unfinished_surveys: 'Vous avez des enquêtes non terminées: ',
    want_to_checkout: 'Êtes-vous sûr de vouloir faire le check-out?',
    selected_store: 'Magasin sélectionné',
    checkout_blocked: 'Check-out bloqué',
    uncompleted_forms: 'Vous avez des formulaires non complétés!',
    checkout_anyway: 'Voulez-vous faire le check-out quand même?',
    go_to_survey: "Aller à l'enquête",
    take_the_survey: 'Vous pouvez maintenant réaliser l´enquête !',
    validity: 'Validité : ',
    search_store: 'Rechercher un magasin...',
    no_results_for_your_search: 'Aucun résultat pour votre recherche',
    find_another_store: 'Cherchez un autre magasin',
    //nuevos al 21-11-2024
    loading: 'Chargement...',
    error_getting_data: "Erreur lors de l'obtention des données.",
    no_information_to_display: 'Aucune information à afficher.',
    unzipping: 'Décompression...',
    saving: 'Enregistrement',
    loading_stores: 'Chargement des magasins...',
    getting_stores: 'Obtention des magasins...',
    request_has_failed: 'Le nombre maximal de tentatives a été atteint. La demande a échoué.',
    a_few_minutes: 'Chargement des magasins...\nCe processus peut prendre quelques minutes.',
    //nuevos al 27-01-2025
    assets_download_completed: 'Téléchargement des ressources de Perfect Store terminé',
    perfect_store_download: 'Téléchargement de la photo de succès de Perfect Store terminé',
    perfect_store_error: 'Erreur lors du téléchargement des ressources de Perfect Store',
    connection_interrupted: 'Connexion interrompue, la photo de succès sera décompressée une fois la connexion rétablie',
    decompressing_perfect_store: 'Décompression de Perfect Store',
    downloading_perfect_store: 'Téléchargement de Perfect Store',
    saving_perfect_store: 'Enregistrement de Perfect Store',
    remain_downloaded: '\nRestant à télécharger ',
    assets: ' ressources.',
    download_complete: 'Téléchargement terminé',

    //Portfolio
    no_brands_to_show: 'Aucune marque à afficher',
    no_products_to_show: 'Aucun produit à afficher',
    try_again_later: 'Réessayez plus tard',
    portfolio: 'Portfolio',
    select_one: "Sélectionnez l'une de nos marques pour voir leurs produits et services.",
    learn_about: 'Découvrez toute la gamme de produits et services dans notre application.',
    //nuevos al 01-08-2024
    brand: 'Marque',
    description: 'Description',
    ingredients: 'Ingrédients',
    data_sheet: 'Fiche technique',

    //Benefits
    points_can_be_exchanged: 'Peut être échangé contre:',
    approved: 'Approuvé',
    cancelled: 'Annulé',
    pending: 'En attente',
    redeemed: 'REDEMANDÉ',
    added_points: 'POINTS AJOUTÉS',
    all: 'Tout',
    my_points: 'Mes Points',
    your_points: 'Vos points',
    delivered: 'Livré',
    no_benefits: 'Aucun avantage encore',
    add_points: 'Gagnez des points avec vos interactions pour les échanger',
    no_history: "Pas encore d'historique",
    redeem_your_points: "Échangez vos points et vous verrez votre historique d'avantages ici",
    pending_approval: "En attente d'approbation",
    when_it_is_approved: "Lorsqu'il sera approuvé, vous le verrez reflété dans votre historique d'avantages",
    unredeemed_benefit: 'Avantage non racheté',
    you_dont_have_enough_points: "Vous n'avez pas suffisamment de points pour échanger cet avantage",
    accept: 'Accepter',
    units_available: ' unités disponibles',
    redeem_benefit: "Échanger l'avantage",
    benefits_mayus: 'AVANTAGES',
    history: 'HISTOIRE',
    there_was_a_mistake: 'Il y avait une erreur',

    //Vouchers
    complete_to_redeem_the_voucher: 'Compléter pour échanger le bon',
    valid_until: "Valide jusqu'à: ",
    quantity_purchased: 'Quantité achetée: ',
    redeem: 'Échanger',
    lumps: 'Gruaux',
    voucher_redeemed: 'Bon échangé avec succès',
    error_redeeming_voucher: "Une erreur s'est produite lors de l'échange du bon. Réessayez.",
    validate_and_redeem_vouchers: 'Valider et échanger des bons',
    to_get_started: 'Pour commencer, entrez ou scannez le QR de votre bon avec votre caméra',
    write_your_code: 'Écrivez votre code...',
    validate: 'Valider',
    back_to_store: 'Retour au magasin',
    scan_qr: 'Scannez le QR',
    scan_on_the_voucher: 'Pour commencer, scannez le QR du bon',
    view_history: 'Voir l’historique',
    voucher_history: 'Historique des bons',
    voucher_history_description:
        'Cet historique vous permet de suivre avec précision les échanges effectués, facilitant ainsi le suivi et la gestion de vos récompenses accumulées.',
    see_more: 'Voir plus',
    see_less: 'Voir moins',

    //Faltantes
    upload_image: "Télécharger l'image",
    uploaded_image: 'Image téléchargée',
    photo: 'Photo',
    edit: 'Modifier',
    delete: 'Supprimer',
    enter_a_comment: 'Entrez un commentaire',
    enter_a_value: 'Entrez une valeur',
    want_to_check_out: 'Êtes-vous sûr de vouloir effectuer le check-out ?',
    not_check_in_again: 'Une fois confirmé, vous ne pourrez pas vous enregistrer à nouveau jusqu´à votre prochaine visite.',

    //Alert
    alert: 'Alerte',
    enter_characters: 'Vous devez entrer 10 caractères après le préfixe',
    numerical_field: 'Le champ à modifier doit être numérique, sans espaces ni lettres.',
    enter_date_of_birth: 'Entrez une date de naissance valide au format AAAA-MM-JJ.',
    session_expired: 'Session expirée',
    your_session_has_expired: 'Votre session a expiré. Veuillez réessayer.',
    error: 'Erreur',
    error_occurred: 'Une erreur est survenue lors de la tentative de changement du mot de passe.',
    email_verification_code_incorrect: "Le code de vérification de l'e-mail est incorrect.",
    phone_verification_code_incorrect: 'Le code de vérification du téléphone est incorrect.',
    no_checkin_found: 'Aucun enregistrement trouvé.',

    //trivia
    your_position: 'Your position',
    play_again: 'Play again!',
    next: 'Next',
    position: 'Position',
    Questions: 'Question:',
    answer_right: 'The correct answer is:',
    game_completed_title1: 'Game completed!',
    game_completed_title2: 'Congratulations!',
    game_completed_title3: 'You finished the trivia.',
    game_completed_title4: 'Ready to see your results? Discover how many answers you got right and challenge yourself to improve your score.',
    game_unfinished_title1: 'Time is up for answering this or the questions.',
    game_unfinished_title2: "But don't worry, keep playing and show your knowledge in the next one!",
    tomorrow_again: 'New attempt tomorrow!',
    complete: 'Complete',
}
